import { } from './js/artists';
import { } from './js/feedback';
import { } from './js/header';
import {} from './js/modal';
import { initHeroScroll } from './js/hero';

initHeroScroll();